@switch (questionType()) {
    @case ('HEADER') {
        <div class="header">
            <h3 [innerHTML]="question().question | safeHtml"></h3>
        </div>
    }
    @case ('SUB_HEADER') {
        <div class="sub-header">
            <h4 [innerHTML]="question().question | safeHtml"></h4>
        </div>
    }
    @case ('YES_NO_HEADER') {
        <div class="yes-no-header">
            <h2 [innerHTML]="question().question | safeHtml"></h2>
        </div>
    }
    @case ('YES_NO') {
        <div class="yes-no">
            <div class="question-text" [innerHTML]="question().question | safeHtml"></div>

            <div class="answer-section">
                <div class="answer-value">
                    {{ getAnswerLabel(answer()?.answer || '') }}
                </div>
            </div>

            <div class="comment-section">
                @if (answer()?.comment) {
                    <div class="comment-text">
                        {{ answer()?.comment }}
                    </div>
                }

                @if (answer()?.photo) {
                    <div class="photo-display">
                        <app-codalt-image
                            [fullUrl]="Settings.RESOURCES_ENDPOINT + 'checklists/' + answer()?.photo"
                            [maintainAspectRatio]="true"
                            [lazy]="false">
                        </app-codalt-image>
                    </div>
                }
            </div>
        </div>
    }
    @case ('YES_NO_ONLY') {
        <div class="yes-no">
            <div class="question-text" [innerHTML]="question().question | safeHtml"></div>

            <div class="answer-section">
                <div class="answer-value">
                    {{ getAnswerLabel(answer()?.answer || '') }}
                </div>
            </div>

            <div class="comment-section">
                @if (answer()?.comment) {
                    <div class="comment-text">
                        {{ answer()?.comment }}
                    </div>
                }

                @if (answer()?.photo) {
                    <div class="photo-display">
                        <app-codalt-image
                            [fullUrl]="Settings.RESOURCES_ENDPOINT + 'checklists/' + answer()?.photo"
                            [maintainAspectRatio]="true"
                            [lazy]="false">
                        </app-codalt-image>
                    </div>
                }
            </div>
        </div>
    }
    @case ('SIGN_OFF') {
        <div class="question-row">
            <div class="question-text" [innerHTML]="question().question | safeHtml"></div>

            <div class="answer-section">
                @if (answer()?.signed_off_at) {
                    <div class="signed-off">
                        Ondertekend door {{ answer()?.assigned_user?.name || '-' }} op
                        {{ answer()?.signed_off_at | date: 'EEE d MMMM' }} om
                        {{ answer()?.signed_off_at | date: 'HH:mm' }}
                    </div>
                } @else {
                    <div class="answer-value">Ondertekenaar: {{ answer()?.assigned_user?.name || '-' }}</div>
                    @if (canSignOff()) {
                        <button (click)="signOff.emit(answer())" mat-stroked-button color="primary" type="button">
                            Akkoord geven
                        </button>
                    } @else {
                        <div class="signed-off pending">Nog niet ondertekend</div>
                    }
                }
            </div>
        </div>
    }
    @case ('TEXT') {
        <div class="question-row">
            <div class="question-text" [innerHTML]="question().question | safeHtml"></div>

            <div class="answer-section">
                <div class="answer-value">
                    {{ answer()?.answer || '-' }}
                </div>
            </div>
        </div>
    }
}
